// BNB
export const DEFAULT_INPUT_CURRENCY = 'BNB'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82'
